import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { BrandSetting } from "../types";

export const getSettingsListByBrand = async (
  brandId: string,
): Promise<BrandSetting[]> => {
  const collectionRef = collection(db, `brands/${brandId}/settings`);

  const q = query(collectionRef, orderBy("order", "asc"));

  const snapshot = await getDocs(q);

  return snapshot.docs.map((doc) => doc.data()) as BrandSetting[];
};
